// ============================================================================
// === Styles de la carte Mapbox ===
// Ce fichier contient les styles spécifiques à la carte.
// Modifier uniquement si nécessaire pour ajuster l'apparence du conteneur.
// ============================================================================

import styled from 'styled-components';

interface MapContainerProps {
  width?: string;
  height?: string;
  debug?: boolean;
}

export const MapContainer = styled.div<MapContainerProps>`
  position: relative;
  width: ${props => props.width || '100%'};
  height: ${props => props.height || '100vh'};
  min-height: 500px;
  overflow: hidden; /* Changé de visible à hidden pour éviter les débordements */
  display: block !important;
  visibility: visible !important;
  opacity: 1 !important;
  background-color: #f0f0f0;
  z-index: 1;
  ${props => props.debug && `
    border: 2px solid red;
  `}
  
  /* Forcer l'affichage des éléments enfants */
  & > * {
    display: block !important;
    visibility: visible !important;
  }
  
  /* Styles pour les éléments internes de Mapbox */
  .mapboxgl-map {
    position: absolute !important;
    top: 0 !important;
    bottom: 0 !important;
    left: 0 !important;
    right: 0 !important;
    width: 100% !important;
    height: 100% !important;
    min-height: 500px !important;
    visibility: visible !important;
    display: block !important;
    z-index: 1 !important;
  }
  
  .mapboxgl-canvas {
    width: 100% !important;
    height: 100% !important;
    min-height: 500px !important;
    outline: none;
    position: absolute !important;
    top: 0 !important;
    left: 0 !important;
    visibility: visible !important;
    display: block !important;
    z-index: 2 !important;
  }
  
  /* S'assurer que le canvas-container est visible */
  .mapboxgl-canvas-container {
    width: 100% !important;
    height: 100% !important;
    position: absolute !important;
  }
  
  /* Assurer que les contrôles sont visibles */
  .mapboxgl-ctrl-top-right {
    display: block !important;
  }
  
  /* Masquer les contrôles de boussole et autres boutons non essentiels pour tous les modes */
  .mapboxgl-ctrl-group > button.mapboxgl-ctrl-compass,
  .mapboxgl-ctrl-group > button.mapbox-gl-draw_trash,
  .mapboxgl-ctrl-group > button.mapboxgl-ctrl-geolocate,
  .mapboxgl-ctrl-group > button.mapboxgl-ctrl-fullscreen {
    display: none !important;
  }
  
  /* Masquer complètement les éléments d'attribution pour tous les modes */
  .mapboxgl-ctrl-attrib-button,
  .mapboxgl-ctrl-attrib {
    display: none !important;
    visibility: hidden !important;
    opacity: 0 !important;
    width: 0 !important;
    height: 0 !important;
    position: absolute !important;
    pointer-events: none !important;
    right: -9999px !important;
  }
  
  /* S'assurer que la carte prend toute la largeur disponible */
  .mapboxgl-canvas-container,
  .mapboxgl-canvas {
    width: 100% !important;
    height: 100% !important;
    left: 0 !important;
    right: 0 !important;
  }
  
  /* Ajuster la taille et la position des contrôles en version mobile */
  @media (max-width: 768px) {
    width: 100% !important;
    left: 0 !important;
    right: 0 !important;
    
    /* Positionner les contrôles en haut à gauche pour éviter la bande à droite */
    .mapboxgl-ctrl-top-right {
      display: none !important;
    }
    
    .mapboxgl-ctrl-top-left {
      top: 10px !important;
      left: 10px !important;
    }
    
    .mapboxgl-ctrl-group {
      margin: 5px !important;
      transform: scale(0.85);
      transform-origin: top left;
    }
  }

`;

